import { interval, Observable } from "rxjs";
import { filter, first, map, switchMap } from "rxjs/operators";
import { DomScriptUtils } from "../../../application/core/shared/dom-methods/DomScriptUtils";
import { IScriptParams } from "../../../application/core/models/IScriptParams";
import { ICardinal } from "./ICardinal";

export class CardinalScriptLoader {
  private static readonly scriptTagId = "cardinalCommerce";

  loadScript(
    url: string,
    options?: { integrity?: string; crossorigin?: string },
  ): Observable<ICardinal> {
    this.removeExistingScript();

    const scriptOptions: IScriptParams = {
      src: url,
      id: CardinalScriptLoader.scriptTagId,
      ...options,
    };

    return DomScriptUtils.insertScript("head", scriptOptions).pipe(
      switchMap(() => this.waitForCardinalInit()),
    );
  }

  private removeExistingScript(): void {
    const existingScript = document.getElementById(
      CardinalScriptLoader.scriptTagId,
    );
    if (existingScript) {
      existingScript.parentNode?.removeChild(existingScript);
    }
  }

  private waitForCardinalInit(): Observable<ICardinal> {
    return interval().pipe(
      // @ts-ignore
      map(() => window.Cardinal),
      filter(Boolean),
      first(),
    ) as Observable<ICardinal>;
  }
}
